import React from "react";
import i18next from "translations/i18n";

i18next.addResourceBundle(
  "de",
  "home",
  {
    "meta-title": "KÜCHEN: Küchenvergleich / Küchenhersteller vergleichen mit KitchenAdvisor",
    "meta-description":
      "KÜCHEN ➔ Mit KitchenAdvisor Küchen vergleichen ➔ Küchenvergleich mit 3 unabhängigen ✚ kostenlosen Angeboten für eine Küche von Küchenstudios ganz in deiner Nähe ✅ Küchen zum Festpreis ✅ Unverbindliche Angebote erhalten ✅ Beim Küchenkauf bis zu 3.000€ sparen ☎ 040-999994312",
    "meta-keywords": "küchen, küchen vergleichen",

    "header-image-alt": "Küchen - Küchenpreise vergleichen",
    "header-h1-1": "Der einfachste Weg",
    "header-h1-2": "Küchen zu vergleichen",
    "header-h2": "Erhalte neutrale Vorschläge & Preisangebote für deine neue Küche ganz in deiner Nähe.",
    "header-h3": "Alles online. Alles kostenlos.",
    "seo-title": "Küchenpreise vergleichen mit KitchenAdvisor",
    "seo-text": `Die Preise auf dem Markt für <strong>Küchen</strong> sind intransparent und schwer zu verstehen. Daher hat
    sich KitchenAdvisor das Ziel gesetzt, den Küchenkauf neu zu gestalten und euch die Möglichkeit zu geben
    einen <strong>fairen Küchenpreis</strong> und vor allem auch die richtige Küche zu bekommen. Wir sind das
    Schweizer Taschenmesser unter den Online-Plattformen, da wir Makler, Vergleichsportal, Ratgeber und bester
    Freund gleichzeitig sind. Wir umgehen mit euch sämtliche Fallstricke beim <a href="https://www.kitchenadvisor.de/kueche-kaufen/">Küche kaufen</a> - um tatsächlich die
    besten Preise zu bekommen, solltet ihr euch mehrere Angebote von Küchenhändlern holen - also
    <strong>Küchenpreise vergleichen</strong>! Bei erfolgreicher Vermittlung erhält KitchenAdvisor dafür von
    den Partner-Küchenstudios eine Provision. KitchenAdvisor geht noch einen Schritt weiter und gibt euch nach
    Beantwortung einiger Fragen in unserem <a href="https://www.kitchenadvisor.de/kuechenkonfigurator/">Küchenkonfigurator</a> einen Küchenentwurf und einen Schätzpreis, mit welchem ihr schonmal euren
    Geldbeutel mit der harten Küchen-Realität vergleichen könnt. Das eignet sich auch hervorragend, falls ihr
    noch in der Rohbau-Phase seid, aber schonmal eine Einschätzung haben möchtet, wie teuer eure <a href="https://www.kitchenadvisor.de/einbaukuechen/">Einbauküche</a>
    sein wird. So einfach wie bei uns kannst du sonst nirgends deine <a href="https://www.kitchenadvisor.de/kueche-selber-zusammenstellen/">Küche selber zusammenstellen</a>! Also jetzt ran und online eure Küche mit KitchenAdvisor planen - jetzt
    <a href="https://www.kitchenadvisor.de/">Küchen</a> auf kitchenadvisor.de vergleichen, völlig umsonst und
    unverbindlich!`,

    "sectioncontact-h1": "Kontaktiere uns <br />& wir helfen dir bei deinen Fragen!",
    "sectioncontact-input-email": "E-Main eingeben*",
    "sectioncontact-input-desc": "Stelle hier deine Fragen",
    "sectioncontact-button": "Jetzt Frage Stellen",
    "sectioncontact-thankyou-h1": "Vielen Dank für deine Frage!",
    "sectioncontact-thankyou-h2": "Wir werden uns umgehend bei dir melden!",
    "sectioncontact-constraints-email-add": "Bitte gib deine E-Mail Adresse an.",
    "sectioncontact-constraints-email-fix": "Bitte gib eine gültige E-Mail Adresse an.",
    "sectioncontact-constraints-desc": "Bitte gib deine Frage an.",

    "fullscreen-mode": "Zum Vollbild-Modus",

    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",

    closed: "geschlossen",
    "by-arrangement": "Nach Vereinbarung",

    "reviews-h1": "<span>Unsere <strong>zufriedenen Kunden</strong> sprechen für sich selbst</span>",
    "reviews-h2": "Hunderte von Kunden deutschlandweit kochen bereits in ihrer neuen Wunschküche dank KitchenAdvisor",

    "calendar-when-visit": "Wann würdest du gerne das Studio besuchen?",
    "calendar-set-here": "Hier angeben",
    "calendar-confirm-appointment": "Termin bestätigen",
    "calendar-full-day": "Ganztags",
    "calendar-until-noon": "Vormittags",
    "calendar-afternoon": "Nachmittags",
    "calendar-appointment": "Du hast bereits einen Termin",
    "calendar-on": "am",
    "calendar-at": "um",
    "calendar-change": "Termin ändern",
    "calendar-delete": "Termin löschen",
    "calendar-thanks": "Vielen Dank! Dein Termin wurde gespeichert!",

    back: "Zurück",
    cancel: "Abbrechen",
    save: "Speichern",
    next: "Weiter",
    yes: "Ja",
    no: "Nein",
  },
  true,
  true
);

i18next.addResourceBundle(
  "en",
  "home",
  {
    "meta-title": "Compare kitchen prices in Germany with KitchenAdvisor",
    "meta-description":
      "KitchenAdvisor helps you to buy your dream kitchen in Germany ✓ free kitchen designs ✓ offers within 24 hours ✓ English-speaking kitchen planners",
    "meta-keywords": "Kitchen, Kitchen planner, Kitchen planning",

    "header-image-alt": "Kitchens - Compare prices",
    "header-h1-1": "The easiest way to",
    "header-h1-2": "PLAN YOUR KITCHEN",
    "header-h2": "Get objective proposals & offers for your new kitchen from stores right around the corner.",
    "header-h3": "All online. All free.",

    "sectioncontact-h1": "Contact us today & we’ll help right away",
    "sectioncontact-input-email": "Enter E-Mail*",
    "sectioncontact-input-desc": "Post your question here:",
    "sectioncontact-button": "Submit",
    "sectioncontact-thankyou-h1": "Thank you for sending your question!",
    "sectioncontact-thankyou-h2": "We will contact you immediately!",
    "sectioncontact-constraints-email-add": "Please enter your e-mail address.",
    "sectioncontact-constraints-email-fix": "Please enter correct e-mail address.",
    "sectioncontact-constraints-desc": "Please enter your question",

    "fullscreen-mode": "Fullscreen mode",

    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",

    closed: "Closed",
    "by-arrangement": "By Arrangement",

    "reviews-h1": "<span>Our <strong>happy customers</strong> speak for themselves</span>",
    "reviews-h2": "Hundreds of customers all over Germany already cook in their dream kitchen thanks to KitchenAdvisor",

    "calendar-when-visit": "What time would you like to visit the studio?",
    "calendar-set-here": "Enter here",
    "calendar-confirm-appointment": "Confirm",
    "calendar-full-day": "Full day",
    "calendar-until-noon": "Until noon",
    "calendar-afternoon": "Afternoon",
    "calendar-appointment": "You already have an appointment",
    "calendar-on": "on",
    "calendar-at": "at",
    "calendar-change": "Change appointment",
    "calendar-delete": "Delete appointment",
    "calendar-thanks": "Thanks a lot! Your appointment has been saved!",

    back: "Back",
    cancel: "Cancel",
    save: "Save",
    next: "Next",
    yes: "Yes",
    no: "No",
  },
  true,
  true
);
